<template>
    <div class="modal fade" :id="'createTypeModal_'+id" data-backdrop="static" tabindex="-2" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <form @submit.prevent="submitData" class="form">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ !isEdit ? $t('crm-setting.pipeline.activityType.creation') : $t('crm-setting.pipeline.activityType.modification') }}</h5>
                        <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal" aria-label="Close">
                            <span class="svg-icon svg-icon-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                                        fill="currentColor"/>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                                        fill="currentColor"/>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div class="modal-body">
                        <RequiredText />
                        <Input
                            containerClass="col-12 mt-2 mb-5"
                            :name="`${id}-name`"
                            type="text"
                            :label="$t('crm-setting.pipeline.activityType.name')"
                            labelClass="form-label"
                            :inputClass="'form-control form-control-lg form-control-solid'"
                            :isRequired="true" size="lg"
                            v-model="formData.name"
                        />
                        <SelectIcon containerClass="col-12 mt-2 mb-5" :label="$t('crm-setting.pipeline.activityType.icon')" :required="true" @get-icon="getIcon" :iconItem="formData.icon" :data="activityIcons"/>
                        <SelectColor containerClass="col-12 mt-2" :label="$t('crm-setting.pipeline.activityType.color')" :required="true" @get-color="getColor" v-model="formData.color" :data="colors" :iconParent="'createTypeModal_'+id"/>
                    </div>
                    <div class="modal-footer">
                        <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
                        <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoadingType"></Button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
    import {ref, defineProps, onMounted, computed} from 'vue'
    import {useStore} from "vuex";
    import RequiredText from "@/components/RequiredText"
    import SelectColor from "@/Modules/CRM/components/SelectColor";
    import SelectIcon from "@/Modules/CRM/components/SelectIcon";
    import Input from "@/components/Input.vue";
    import Button from "@/components/Button.vue"
    import OutlineButton from "@/components/OutlineButton.vue"

    const store = useStore()

    const props = defineProps({
        type: { 
            type: Object, 
            default: {
                name: '',
                icon: '',
                color: ''
            } 
        },
        id: {
            type: String,
            required: true
        },
        parent: {
            type: String,
            required: false
        },
        isEdit: {
            type: Boolean,
            required: false
        }
    })

    const emits = defineEmits(['load', 'addType'])

    const activityIcons = computed(() => store.getters['activityTypes/getActivityIcons'])
    const activityTypes = computed(() => store.getters['activityTypes/getActivityTypes'])
    const colors = computed(() => {
        const allColors = Object.values(activityTypes.value)
            .map(item => item ? item.color : null)
            .filter(color => color !== null);

        return [...new Set(allColors)].map(color => ({ value: color }));
    });

    const formData = ref(props.type)
    const isLoadingType = ref(false)

    function getIcon(value){
        formData.value.icon = value
    }

    function getColor(value){
        formData.value.color = value
    }

    function submitData(){
        if(!props.isEdit){
            createTypeData()
        }else{
            updateTypeData()
        }
    }

    function closeModal(){
        if(props.parent){
            $('#'+props.parent).modal('toggle')
        }
        $('#createTypeModal_'+props.id).modal('toggle')
    }

    function createTypeData(){
        isLoadingType.value = true
        store.dispatch('activityTypes/createActivityType', formData.value)
            .then((response) => {
                emits('addType', response.data?.id)
                emits('load')
                isLoadingType.value = false
                closeModal()
                formData.value.name = ''
                formData.value.icon = ''
                formData.value.color = ''
                window.toastr['success'](i18n.global.t('notification.activityType_created'))
            })
            .catch(err => {
                isLoadingType.value = false
            })
    }

    function updateTypeData(){
        isLoadingType.value = true
        store.dispatch('activityTypes/updateActivityType', formData.value)
            .then((response) => {
                emits('load')
                isLoadingType.value = false
                closeModal()
                formData.value.id = ''
                formData.value.name = ''
                formData.value.icon = ''
                formData.value.color = ''
                window.toastr['success'](i18n.global.t('notification.activityType_updated'))
            })
            .catch(err => {
                isLoadingType.value = false
            })
    }

    onMounted(() => {
        store.dispatch('activityTypes/loadActivityTypes')
        store.dispatch('activityTypes/loadActivityIcons')
    })
</script>